import { Box, Grid, Typography, Link } from '@mui/material'
import React from 'react'
import { useHistory } from 'react-router'
import { AppRouteURI } from 'router/RoleBasedAccess'
import useStyles from '../../app/Styles'

const HeaderView = () => {
    const classes = useStyles()
    const history = useHistory()

    return (
        <Grid item xs={12} container>

            <Box style={{ padding: '12px' }}>
                <Typography variant="body1">
                    <Link href={AppRouteURI.HOME} color="inherit" underline="none">
                        Helios Workforce
                    </Link>
                </Typography>
            </Box>
        </Grid>
    )
}

export default HeaderView
